import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementContextType } from "../../../../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";
import { getIdentityVerificationRequirementStatus } from "./getIdentityVerificationRequirementStatus";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";

export const getIdentityVerificationPayerRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined
): { pill: WSPillProps; secondaryText?: string } => {
  return getIdentityVerificationRequirementStatus(
    requirement,
    contextItem,
    identityVerificationRequest,
    RequirementContextType.Payee
  );
};
